import { api } from './api';

export interface PurchaseSubscriptionPayload {
    plan_name: string;
    price: number;
}

export interface PurchaseSubscriptionResponse {
    success: boolean;
    message: string;
    data?: {
        payment_id?: string;
        status?: string;
        plan_name?: string;
        price?: number;
    };
}

export const purchaseSubscription = (
    token: string,
    payload: PurchaseSubscriptionPayload
): Promise<PurchaseSubscriptionResponse> =>
    api.post<PurchaseSubscriptionResponse>('/subscriptions/purchase', payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export interface UnsubscribePayload {
    email: string;
    first_name: string;
    last_name: string;
    iban_last_5: string;
}

export interface UnsubscribeResponse {
    success: boolean;
    message: string;
}

export const unsubscribeUser = (
    payload: UnsubscribePayload
): Promise<UnsubscribeResponse> =>
    api.post<UnsubscribeResponse>('/subscriptions/unsubscribe', payload);
